import { Route } from 'vue-router';

import { PublicSettings } from '@/enums/publicSettings.enum';
import store from '@/store/store';
import { tryParseBoolean } from '@witkac/utils/tryParseBoolean';

/**
 * Zwraca typy raportów
 *
 * @export
 * @param {*} [state]
 * @returns {any[]}
 */
export function getReportTypes(state?: any): any[] {
  if (!state) {
    state = store.state;
  }
  return JSON.parse(state.setting.settings[PublicSettings.HARDCODED_REPORTS]?.value || '[]');
}

/**
 * Zwraca wybrany typ raportu
 *
 * @export
 * @param {Route} route
 * @returns {*}
 */
export function getSelectedReportType(route: Route): any {
  const hideGeneralReport = tryParseBoolean(
    store.state.setting.settings[PublicSettings.HIDE_GENERAL_REPORT]?.value,
    false
  );
  const reportTypes = getReportTypes();
  if (!route.query.type && hideGeneralReport) {
    return reportTypes[0];
  }
  if (!route.query.type) {
    return;
  }
  return reportTypes.find(type => type.id === route.query.type);
}
